import { BrainstormClearErrorsAction } from './../../store/action/BrainstormActions';
import { SurveyClearErrorsAction } from './../../store/action/SurveyActions';
import { TrainingClearAction, TrainingClearErrorsAction } from './../../store/action/TrainingActions';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, Loading, ToastController, LoadingController } from 'ionic-angular';
import { TrainingDetailsPage } from '../training-details/training-details';
import { TrainingCategory, AppliedTraining, Training } from '../../model/TrainingModel';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppStore } from '../../store/AppStore';
import { TrainingListAction, TrainingListClientAction, TrainingListAppliedAction, TrainingStatusUpdateAction } from '../../store/action/TrainingActions';
import { LoginPage } from '../login/login';
import { TrainingService } from '../../services/TrainingSevice';
import { ClearNotificationsAction } from '../../store/action/NotificationActions';
import { LogoutAction } from '../../store/action/UserActions';

import _ from 'lodash';

import * as Sentry from "@sentry/browser";
import { CronosClearErrorsAction } from '../../store/action/CronosActions';

@IonicPage()
@Component({
  selector: 'page-training',
  templateUrl: 'training.html'
})
export class TrainingPage {

  public emaisItems: Array<TrainingCategory>;
  public clientItems: Array<TrainingCategory>;
  public filteredItems: Array<TrainingCategory> = [];
  public appliedItems: Array<AppliedTraining>;
  public searchInput: string = null;
  public shouldShowCancelSearch: boolean = false;
  public organizationName: string = '';
  public isLoading: boolean;
  public loader: Loading;

  private userSubscription: Subscription;
  private trainingSubscription: Subscription;

  private userId: number;
  private clientId: number;
  private tapped: boolean;
  private tappedItem: AppliedTraining;
  private tappedType: number;
  private firstTime: boolean;
  private loggingOff: boolean;
  private loaded: boolean;
  private loadedClient: boolean;
  private loadedApplied: boolean;
  private fromNotification: boolean;

  private refresher: any = null;
  private clickedTrainingId: number;
  
  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,
    private store: Store<AppStore>,
    private toastCtrl: ToastController,
    private loadingCtrl: LoadingController,
    private trainingService: TrainingService
  ) {

    this.loggingOff = false;
    if (this.navParams.get('trainingId') != null) {
      this.clickedTrainingId = this.navParams.get('trainingId');
    }

  }

  logoff() {
    this.presentToast('Acesso expirado. Efetue login novamente. (11)');
    localStorage.removeItem('expirationDate');
    this.store.dispatch(new LogoutAction());
    this.store.dispatch(new SurveyClearErrorsAction());
    this.store.dispatch(new TrainingClearErrorsAction());
    this.store.dispatch(new BrainstormClearErrorsAction());
    this.store.dispatch(new ClearNotificationsAction());
    this.store.dispatch(new CronosClearErrorsAction());
    this.navCtrl.setRoot(LoginPage);
  }

  ionViewWillEnter() {

    this.loaded = false;
    this.loadedClient = false;
    this.loadedApplied = false;
    this.fromNotification = false;
    this.isLoading = false;
    this.tapped = false;
    this.tappedItem = null;
    this.tappedType = null;

    this.userSubscription = this.store.select('userState').subscribe(userState => {
      if (userState.expired == true && !this.loggingOff) {
        this.loggingOff = true;
        this.logoff();
      }
      if (userState.user != null) {
        this.userId = userState.user.id;
        this.clientId = userState.user.clienteId;
        this.organizationName = userState.organization != null ? userState.organization.nomeFantasia: "";

        Sentry.configureScope(scope => {
          scope.setUser({ id: this.userId.toString(), username: userState.user.nome });
        });

        Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingListAction'});
        this.store.dispatch(new TrainingListAction());
      }
    });

    this.trainingSubscription = this.store.select('trainingState').subscribe(trainingState => {
      
      if ((trainingState.loading || trainingState.loadingClient || trainingState.loadingApplied ||trainingState.loadingStatus) && !this.isLoading && !this.loggingOff) {
        Sentry.captureEvent({message: 'Training -> trainingState.loading', extra: { 'state': JSON.stringify(trainingState) } });
        if (this.loader == null) {
          this.loader = this.loadingCtrl.create({
            content: "Aguarde..."
          });
          this.loader.present();
        }
        this.isLoading = true;
      }
      if (!trainingState.loading && !trainingState.loadingClient && !trainingState.loadingApplied && !trainingState.loadingStatus && this.isLoading) {
        Sentry.captureEvent({message: 'Training -> trainingState.loadingEnd', extra: { 'state': JSON.stringify(trainingState) } });
        this.loader.dismiss();
        this.loader = null;
        this.isLoading = false;
      }
      if (trainingState.error || trainingState.errorClient || trainingState.errorApplied || trainingState.errorStatus) {
        Sentry.captureEvent({message: 'Training -> trainingState.error', extra: { 'state': JSON.stringify(trainingState) } });
        setTimeout(() => {
          if (!this.loggingOff) {
            this.presentToast('Erro ao trazer os dados dos treinamentos');
          }
        }, 1000);
        if (this.refresher != null) {
          this.refresher.complete();
          this.refresher = null;
        }
        Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingClearErrorsAction'});
        this.store.dispatch(new TrainingClearErrorsAction());
        return;
      }
      if (this.tapped && !this.isLoading && !trainingState.loadingStatus && !trainingState.errorStatus && !this.loggingOff) {
        Sentry.captureEvent({message: 'Training -> trainingState.tapped', extra: { 'state': JSON.stringify(trainingState) } });
        this.tapped = false;
        Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingClearAction'});
        this.store.dispatch(new TrainingClearAction());
        this.navCtrl.push(TrainingDetailsPage, {
          item: this.tappedItem,
          type: this.tappedType,
          firstTime: this.firstTime
        });
        return;
      }
      if (!this.loaded && trainingState.loading == false && trainingState.error == false && trainingState.categories != null) {
        Sentry.captureEvent({message: 'Training -> trainingState.loaded', extra: { 'state': JSON.stringify(trainingState) } });
        this.loaded = true;
        Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingListAppliedAction'});
        this.emaisItems = trainingState.categories;
        if (this.clientId != 1) {
          Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingListClientAction'});
          this.store.dispatch(new TrainingListClientAction({ clientId: this.clientId }));
        } else {
          this.loadedClient = true;
          this.clientItems = new Array<TrainingCategory>();
          this.store.dispatch(new TrainingListAppliedAction({ userId: this.userId }));
        }
      } else if (this.loaded && !this.loadedClient && trainingState.loadingClient == false && trainingState.errorClient == false && trainingState.categoriesClient != null) {
        this.loadedClient = true;
        this.clientItems = trainingState.categoriesClient;
        this.store.dispatch(new TrainingListAppliedAction({ userId: this.userId }));
      } else if (this.loaded && this.loadedClient && !this.loadedApplied && trainingState.loadingApplied == false && trainingState.errorApplied == false && trainingState.appliedTrainings != null) {
        Sentry.captureEvent({message: 'Training -> trainingState.loadedApplied', extra: { 'state': JSON.stringify(trainingState) } });
        this.loadedApplied = true;
        this.appliedItems = trainingState.appliedTrainings;
      }
      if (this.emaisItems != null && this.clientItems != null && this.appliedItems != null && !this.tapped && this.loaded == true && this.loadedClient == true && this.loadedApplied == true) {
        if (this.refresher != null) {
          this.refresher.complete();
          this.refresher = null;
        }
        this.changeList(null);
        if (this.clickedTrainingId != null && !this.fromNotification && !this.isLoading) {
          Sentry.captureEvent({message: 'Training -> trainingState.fromNotification', extra: { 'state': JSON.stringify(trainingState) } });
          this.fromNotification = true;
          let achou = false;
          this.filteredItems.forEach(cat => {
            if (!achou) {
              cat.subcategorias.forEach(subcat => {
                if (!achou) {
                  subcat.cursos.forEach(curso => {
                    if (!achou && curso.id == this.clickedTrainingId) {
                      achou = true;
                      this.clickedTrainingId = null;
                      this.itemTapped(null, curso, cat.type);
                    }
                  });
                }
              });
            }
          });
          if (!achou) {
            this.presentToast('Curso indisponível ou expirado!');
          }
        }
      }
    });
    
  }

  ionViewWillLeave() {
    if (this.userSubscription != null) this.userSubscription.unsubscribe();
    if (this.trainingSubscription != null) this.trainingSubscription.unsubscribe();
  }

  refreshData(ref) {
    this.refresher = ref;
    this.loaded = false;
    this.loadedClient = false;
    this.loadedApplied = false;
    Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingListAction [refreshData]'});
    this.store.dispatch(new TrainingListAction());
  }

  itemTapped(event, item: Training, type: number) {
    this.tapped = true;
    let applied = this.appliedItems.find(x => x.cursoId == item.id);
    applied.termoAceite = item.termoAceite;
    applied.termoAceiteId = item.termoAceiteId;
    applied.termoAdesao = item.termoAdesao;
    applied.termoAdesaoId = item.termoAdesaoId;
    applied.certificado = item.certificado;
    this.firstTime = false;
    if (applied.status == 0 || applied.status == 1) {
      applied.status = 2;
      applied.dataInicio = new Date();
      this.firstTime = true;
    }
    this.tappedItem = applied;
    this.tappedType = type;
    Sentry.addBreadcrumb({message: 'Training -> Dispatch -> TrainingStatusUpdateAction'});
    this.store.dispatch(new TrainingStatusUpdateAction({ data: applied }));
  }
  
  changeList(e) {
    this.emaisItems.forEach(x => { x.type = 1 });
    this.clientItems.forEach(x => { x.type = 2 });
    let items: Array<TrainingCategory> = this.emaisItems.concat(this.clientItems);
    items.forEach(categoria => {
      if (categoria.type == 1) {
        categoria.subcategorias = categoria.subcategorias.filter(x => x.cursos.find(y => y.publico == true) != null);
      }
      categoria.subcategorias.forEach(subcat => {
        subcat.cursos = subcat.cursos.filter(x => this.appliedItems.find(y => y.cursoId == x.id) != null); // && y.status != 3 && y.status != 4
      });
      categoria.subcategorias = categoria.subcategorias.filter(x => x.cursos != null && x.cursos.length > 0);
    });
    items = items.filter(x => x.subcategorias != null && x.subcategorias.length > 0);
    items.forEach(categoria => {
      _.forEach(categoria.subcategorias, subcat => {
        subcat.cursos.forEach(curso => {
          if (curso.imagemCapaId != null && (curso.imagemCapa == null || curso.imagemCapa == '')) {
            let clientIdImage = 1;
            if (categoria.type == 2) {
              clientIdImage = this.clientId;
            }
            this.trainingService.getImageTraining(clientIdImage, curso.imagemCapaId)
              .subscribe(data => {
                curso.imagemCapa = data.imagem;
              });;
          }
          const appliedData = this.appliedItems.find(x => x.cursoId == curso.id);
          if (appliedData != null) {
            curso.percentual = Math.round((appliedData.totalPaginaRealizadaCurso / appliedData.totalPaginaCurso) * 100);
            if (curso.percentual > 100) {
              curso.percentual = 100;
            }
            curso.status = appliedData.status;
          }
        });
      });
    });
    this.filteredItems = items;
  }

  search(e) {
    this.shouldShowCancelSearch = true;
    this.changeList(e);
    this.filteredItems = this.filteredItems.filter(x => 
      x.descricao.indexOf(this.searchInput) >= 0 ||
      x.subcategorias.find(y => y.descricao.indexOf(this.searchInput) >= 0) != null ||
      x.subcategorias.find(y => y.cursos.find(z => z.titulo.indexOf(this.searchInput) >= 0) != null) != null ||
      x.subcategorias.find(y => y.cursos.find(z => z.descricao.indexOf(this.searchInput) >= 0) != null) != null
    );
  }

  cancelSearch(e) {
    this.searchInput = '';
    this.shouldShowCancelSearch = false;
    this.changeList(null);
  }

  presentToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: 'top'
    });  
    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/training/training.ts